import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';
import { useAliveController } from 'react-activation';
import dayjs from 'dayjs';

import Btn from '../../../components/Btn/Btn';
import Dialog from '../../../components/Dialog/Dialog';
import { CONTEXT, MICROCONTEXT } from '../../../config';
import { deleteForum, removeForumAction } from '../../../actions/forum';
import { logging, logPostInfo } from '../../../actions/log';
import styles from './ForumLineNoTag.module.less';
import { formatNumber } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { forumData = {}, logInfo, softData = {} } = props;
  const logInfoData = useSelector(selectLogInfo);
  const [showDialog, setShowDialog] = useState(false); // 是否展示弹窗
  const { dropScope, getCachingNodes } = useAliveController();

  useEffect(() => {}, []);

  const handleForum = useCallback(
    forumDataInfo => {
      getCachingNodes().forEach(item => {
        if (item.id.indexOf(forumDataInfo.id) > -1) {
          dropScope(/forumdetail/);
        }
      });
      setTimeout(() => {
        dispatch(
          logging({
            category: 'C',
            action: logInfo.action,
            label: '',
            param2: {
              source: logInfo.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              id: forumDataInfo.id,
              softid: softData.softID,
              type: logInfo.type,
            },
          }),
        );
        dispatch(
          logPostInfo({
            source_p: logInfoData.source,
            source_pp: logInfoData.source_p,
          }),
        );
        history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${forumDataInfo.id}`);
      }, 50);
    },
    [forumData],
  );

  const handleEditForum = useCallback(
    forumDataInfo => {
      if (forumData.id) {
        dispatch(
          logging({
            category: 'C',
            action: 'Forum_Edit',
            label: '',
            param2: {
              source: logInfo.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              id: forumDataInfo.id,
            },
          }),
        );
        history.push(`${CONTEXT}/formpublish?type=${forumDataInfo.type}&id=${forumDataInfo.id}`);
      }
    },
    [forumData],
  );

  const handleRemoveColectForum = useCallback(forumDataInfo => {
    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Remove',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: forumDataInfo.id,
        },
      }),
    );
    if (forumDataInfo.id) {
      dispatch(
        removeForumAction({
          actionType: 1,
          targetId: forumDataInfo.id,
        }),
      );
    }
  }, []);

  const handleDeleteForumSure = useCallback(
    forumDataInfo => {
      if (forumDataInfo.id) {
        dispatch(
          logging({
            category: 'C',
            action: 'Forum_Delete',
            label: '',
            param2: {
              source: logInfo.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              id: forumDataInfo.id,
            },
          }),
        );
        dispatch(
          deleteForum({
            id: forumDataInfo.id,
          }),
        );

        setShowDialog(false);
      }
    },
    [forumData],
  );

  const handleShowCloseDialog = useCallback(
    visible => {
      dispatch(
        logging({
          category: 'C',
          action: 'Forum_Delete_Dialog_Show_Cancle',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: forumData.id,
            visible,
          },
        }),
      );
      setShowDialog(visible);
    },
    [forumData],
  );

  return (
    <div
      className={styles.forum_item}
      onClick={() => {
        handleForum(forumData);
      }}
    >
      <div className={styles.forum_type}>
        {forumData.type === 1 && <div className={styles.forum_type_1} />}
        {forumData.type === 2 && <div className={styles.forum_type_2} />}
      </div>
      <div className={styles.forum_cont}>
        <div className={styles.forum_title_box}>
          <div
            className={styles.forum_title}
            // onClick={() => {
            //   handleForum(forumData);
            // }}
          >
            {forumData.title}
          </div>
          {forumData.top === 1 && (
            <span
              className={styles.forum_recommend}
              // onClick={() => {
              //   handleForum(forumData);
              // }}
            />
          )}
        </div>
        {forumData.state === 0 && location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1 && (
          <div className={styles.forum_user_msg}>
            <span className={styles.forum_msg_icon} />
            <span className={styles.forum_msg}>审核未通过</span>
            <span className={styles.forum_msg_desc}>
              {forumData.cause || '未通过原因：含有敏感词，请重新编辑后提交'}
            </span>
          </div>
        )}
        {forumData.state === 1 && location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1 && (
          <div className={styles.forum_user_msg}>
            <span className={styles.forum_msg_icon} />
            <span className={styles.forum_msg}>审核中</span>
            <span className={styles.forum_msg_desc}>
              {forumData.cause || '审核通过后会自动提交'}
            </span>
          </div>
        )}
        {/* {forumData.state === 2 && location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1 && (
          <div className={styles.forum_user_msg}>
            <span className={styles.forum_msg_desc}>已成功发布</span>
          </div>
        )} */}
        {forumData.state === 3 && location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1 && (
          <div className={styles.forum_user_msg}>
            <span className={styles.forum_msg_icon} />
            <span className={styles.forum_msg}>运营下架</span>
            <span className={styles.forum_msg_desc}>{forumData.cause || '审核不通过'}</span>
          </div>
        )}
      </div>
      <div className={styles.forum_rsc}>
        <div
          className={styles.forum_rsc_time}
          // onClick={() => {
          //   handleForum(forumData);
          // }}
        >
          <span className={styles.forum_rsc_time_ymd}>
            {dayjs(forumData.createTime).format('YYYY-MM-DD')}
          </span>
          <span className={styles.forum_rsc_time_hm}>
            {dayjs(forumData.createTime).format('HH:mm')}
          </span>
        </div>
        <div className={styles.forum_rscs}>
          <div
            className={styles.forum_rsc_item}
            // onClick={() => {
            //   handleForum(forumData);
            // }}
          >
            <span className={`${styles.forum_icon} iconfont icon-fread`} />
            <span className={styles.forum_rsc_text}>
              {formatNumber((forumData.datas && forumData.datas.watchCount) || 0)}
            </span>
          </div>
          <div
            className={styles.forum_rsc_item}
            // onClick={() => {
            //   handleForum(forumData);
            // }}
          >
            <span className={`${styles.forum_icon} iconfont icon-fspot`} />
            <span className={styles.forum_rsc_text}>
              {formatNumber((forumData.datas && forumData.datas.zanCount) || 0)}
            </span>
          </div>
          <div
            className={styles.forum_rsc_item}
            // onClick={() => {
            //   handleForum(forumData);
            // }}
          >
            <span className={`${styles.forum_icon} iconfont icon-fcomment`} />
            <span className={styles.forum_rsc_text}>
              {formatNumber((forumData.datas && forumData.datas.commentCount) || 0)}
            </span>
          </div>
          {location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1 && (
            <div className={styles.forum_opt}>
              <span className={`${styles.forum_opt_icon} iconfont icon-fmanage`} />
              <span className={styles.forum_opt_text}>管理</span>
              <div className={styles.forum_opt_items}>
                {/* 运营下架，不显示可编辑按钮 */}
                {!(forumData.state === 1 || forumData.state === 3) && (
                  <span
                    className={styles.forum_opt_item}
                    onClick={() => {
                      handleEditForum(forumData);
                    }}
                  >
                    编辑
                  </span>
                )}
                <span
                  className={styles.forum_opt_item}
                  onClick={() => {
                    handleShowCloseDialog(true);
                  }}
                >
                  删除
                </span>
              </div>
            </div>
          )}

          {location.pathname.indexOf(`${CONTEXT}/forumlistcollect`) > -1 && (
            <div className={styles.forum_opt}>
              <span className={`${styles.forum_opt_icon} iconfont icon-fdelete`} />
              <span
                className={styles.forum_opt_text}
                onClick={() => {
                  handleRemoveColectForum(forumData);
                }}
              >
                删除
              </span>
            </div>
          )}
        </div>
      </div>
      {showDialog && (
        <Dialog
          title="温馨提示"
          maskStyle={styles.mask}
          containerStyle={styles.mask_container}
          handleClose={() => {
            handleShowCloseDialog(false);
          }}
        >
          <div className={styles.mask_content}>
            <div className={styles.mask_desc}>
              确认删除该
              {forumData.type === 1 && '问题'}
              {forumData.type === 2 && '分享'}吗？
            </div>
            <div className={styles.mask_p_btn}>
              <Btn
                primary
                className={styles.mask_btn}
                handleClick={() => {
                  handleDeleteForumSure(forumData);
                }}
              >
                确定
              </Btn>
              <Btn
                className={styles.mask_btn}
                handleClick={() => {
                  handleShowCloseDialog(false);
                }}
              >
                取消
              </Btn>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};
